import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Auto-recover from stale dynamic-import chunks after a new deploy.
// When the HTML in an open tab references hashed JS chunks that no longer
// exist on the server, the dynamic import rejects — reload once to pick up
// the fresh build instead of showing a blank screen.
const RELOAD_FLAG = "__chunk_reload__";
window.addEventListener("vite:preloadError", (event) => {
  if (sessionStorage.getItem(RELOAD_FLAG)) return;
  sessionStorage.setItem(RELOAD_FLAG, "1");
  event.preventDefault();
  window.location.reload();
});
window.addEventListener("load", () => sessionStorage.removeItem(RELOAD_FLAG));

createRoot(document.getElementById("root")!).render(<App />);
